import { ZoneRow } from './types';
import { isRestoreValueCorrect } from './validationUtils';

/**
 * Calculate totals for restore row based on override values
 */
export const getRestoreValues = (zoneData: ZoneRow[], displayAsPercentage: boolean = true) => {
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
  return days.reduce((acc, day) => {
    // Sum all override values for this day across all zones
    const totalOverride = zoneData.reduce((sum, zone) => {
      const overrideValue = zone.percentages[day].override;
      // Parse value (remove % if present and convert to number)
      const numericValue = parseFloat(overrideValue.replace('%', '')) || 0;
      return sum + numericValue;
    }, 0);
    
    // Format based on displayAsPercentage flag
    if (displayAsPercentage) {
      acc[day] = `${totalOverride.toFixed(2)}%`;
    } else {
      acc[day] = totalOverride.toFixed(2);
    }
    return acc;
  }, {} as Record<string, string>);
};

/**
 * Calculate KCPH restore value based on sum of all override KCPH values
 * Commented out as KCPH total display is not required for business
 */
export const getKCPHRestoreValue = (zoneData: ZoneRow[]) => {
  const totalKCPH = zoneData.reduce((sum, zone) => {
    const overrideValue = parseFloat(zone.kcph.override) || 0;
    return sum + overrideValue;
  }, 0);
  return totalKCPH.toFixed(2);
};

/**
 * Helper function to check if all restore values are 100%
 */
export const areAllRestoreValuesCorrect = (restoreValues: Record<string, string>, displayAsPercentage: boolean = true) => {
  // Check all day columns only (removing KCPH validation)
  const allDaysCorrect = Object.values(restoreValues).every(value => 
    isRestoreValueCorrect(value, displayAsPercentage)
  );
  
  return allDaysCorrect;
};